// extracted by mini-css-extract-plugin
module.exports = {"addButton":"tabsStyles_addButton__Raqcq","select":"tabsStyles_select__MMaCw","search":"tabsStyles_search__3zlyy"};